/**
 * GENERATED BY KRPC GEN - LESS MODIFY BY HAND
 * report-service.ts  2026-05-15T13:37:49+08:00
 */
import type { R, RpcService, MethodConfig as M } from 'krpc-base'

import type { MediaReportReq } from './wy-dto'

const _ = 'Report/'

export class ReportService {
  constructor(readonly r: RpcService) {}
  // 短视频/作品等内容投诉举报
  reportMedia(d: MediaReportReq, m?: M): R<boolean> {
    return this.r.async(_ + 'reportMedia', d, m)
  }
}
